var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 74,
    viewBox: "0 0 87 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4048 14.3295H12.7931C12.2278 14.3295 11.7695 14.7877 11.7695 15.353V59.3648C11.7695 59.9301 12.2278 60.3883 12.7931 60.3883H39.4048C39.9701 60.3883 40.4284 59.9301 40.4284 59.3648V15.353C40.4284 14.7877 39.9701 14.3295 39.4048 14.3295Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.02353,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5716 14.3295H74.2069C74.7722 14.3295 75.2305 14.7877 75.2305 15.353V23.5412C75.2305 24.1065 74.7722 24.5648 74.2069 24.5648H46.5716C46.0064 24.5648 45.5481 24.1065 45.5481 23.5412V15.353C45.5481 14.7877 46.0064 14.3295 46.5716 14.3295Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.02353,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5716 45.0353H74.2069C74.7722 45.0353 75.2305 45.4936 75.2305 46.0588V59.3647C75.2305 59.93 74.7722 60.3883 74.2069 60.3883H46.5716C46.0064 60.3883 45.5481 59.93 45.5481 59.3647V46.0588C45.5481 45.4936 46.0064 45.0353 46.5716 45.0353Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.02353,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5691 29.6823H58.8515C59.4168 29.6823 59.875 30.1405 59.875 30.7058V38.894C59.875 39.4593 59.4168 39.9176 58.8515 39.9176H46.5691C46.0038 39.9176 45.5456 39.4593 45.5456 38.894V30.7058C45.5456 30.1405 46.0038 29.6823 46.5691 29.6823Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.02353,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3937 6.14114H4.60547V67.5529H82.3937V6.14114Z",
    stroke: "white",
    strokeWidth: 1.02353,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7973 2.04709H78.3008V9.63985H85.7973V2.04709Z",
    stroke: "white",
    strokeWidth: 1.02353,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7973 63.4589H78.3008V71.0516H85.7973V63.4589Z",
    stroke: "white",
    strokeWidth: 1.02353,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00822 2.04709H0.511719V9.63985H8.00822V2.04709Z",
    stroke: "white",
    strokeWidth: 1.02353,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00822 63.7677H0.511719V71.3604H8.00822V63.7677Z",
    stroke: "white",
    strokeWidth: 1.02353,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0903 39.9176C71.9167 39.9176 74.2079 37.6263 74.2079 34.7999C74.2079 31.9735 71.9167 29.6823 69.0903 29.6823C66.2639 29.6823 63.9727 31.9735 63.9727 34.7999C63.9727 37.6263 66.2639 39.9176 69.0903 39.9176Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.02353,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.d77ca9ef202be7633e66569656ecb522.svg";
export { ForwardRef as ReactComponent };